export default __webpack_public_path__ + "static/media/Ring_AO2.0d17abd7.png";